export const iconButtonStyles = {
  base: 'inline-flex shrink-0 items-center justify-center rounded-md transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-400 focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50',
  variant: {
    ghost: 'bg-transparent text-brand-950 hover:bg-brand-100 hover:text-brand-950',
    outline: 'border border-brand-700/40 bg-transparent text-brand-950 hover:bg-brand-100',
    danger: 'bg-transparent text-red-600 hover:bg-red-50',
    nav: 'bg-transparent text-brand-100/90 hover:bg-brand-900 hover:text-brand-400',
  },
  size: {
    sm: 'h-10 w-10 min-h-10 min-w-10',
    md: 'h-11 w-11 min-h-11 min-w-11',
  },
} as const;
